export default __webpack_public_path__ + "static/media/invoices.4c9e302c.jpg";